import { render, staticRenderFns } from "./BoxFotosCard.vue?vue&type=template&id=bf11f36c&scoped=true"
import script from "./BoxFotosCard.vue?vue&type=script&lang=js"
export * from "./BoxFotosCard.vue?vue&type=script&lang=js"
import style0 from "./BoxFotosCard.vue?vue&type=style&index=0&id=bf11f36c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf11f36c",
  null
  
)

export default component.exports